/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { useParams, useSearchParams } from 'react-router-dom';
import styles from './PayPalOnboard.module.scss';
import { getCookies } from '../../hooks/useCookies';
import { SERVER_BASE_URL, SERVER_URL_WEB } from '../../redux/apiConstants';

function PayPalOnboard({ eventId }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [existingMerchantId, setExistingMerchantId] = useState(null);

  const email = getCookies('USEREMAIL');
  const userId = getCookies('USERID');
  const params = useParams();

  const [searchParams] = useSearchParams();
  const merchantId = searchParams.get('merchantId');
  const merchantIdInPayPal = searchParams.get('merchantIdInPayPal');
  const productIntentId = searchParams.get('productIntentId');
  const isEmailConfirmed = searchParams.get('isEmailConfirmed');
  const accountStatus = searchParams.get('accountStatus');
  const permissionsGranted = searchParams.get('permissionsGranted');
  const consentStatus = searchParams.get('consentStatus');
  const riskStatus = searchParams.get('riskStatus');

  useEffect(() => {
    if (merchantId) {
      const sendOnboardingData = async () => {
        const eventDataId = params.id;
        try {
          const body = {
            userId,
            merchantId,
            merchantIdInPayPal,
            productIntentId,
            isEmailConfirmed,
            accountStatus,
            permissionsGranted,
            consentStatus,
            riskStatus,
            eventDataId,
          };

          const response = await axios.post(`${SERVER_BASE_URL}/paypal/return`, body);
          if (response.status === 200) {
            toast.success('Account connected successfully.');
            const newUrl = `${window.location.pathname}${''}`;
            window.history.replaceState({}, '', newUrl);
          }
        } catch (error) {
          console.log(error, 'error in log');
        }
      };
      sendOnboardingData();
    }
  }, []);

  useEffect(() => {
    const checkMerchant = async () => {
      try {
        const res = await axios.get(`${SERVER_BASE_URL}/paypal/${userId}/paypal-account`);
        console.log(res, 'check res');
        if (res.data?.account?.merchantId) {
          setExistingMerchantId(res.data?.account?.merchantId);
        }
      } catch (err) {
        console.error('Error checking merchant ID:', err);
      }
    };

    if (userId) checkMerchant();
  }, [userId]);

  const onboard = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${SERVER_BASE_URL}/paypal/onboard`, {
        email,
        eventId,
        userId,
        returnUrl: `${SERVER_URL_WEB}/shows/view-users/${eventId}`,
      });
      window.location.href = response.data.approvalUrl;
    } catch (err) {
      console.error('Onboarding error:', err);
    } finally {
      setLoading(false);
    }
  };

  const useExistingMerchant = async () => {
    setLoading(true);
    try {
      await axios.post(`${SERVER_BASE_URL}/paypal/events/link-paypal`, {
        eventId,
        merchantId: existingMerchantId,
      });
      toast.success('Existing merchant linked successfully');
      setShowModal(false);
    } catch (err) {
      console.error('Error updating merchant:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleOnboardClick = () => {
    if (existingMerchantId) {
      setShowModal(true);
    } else {
      onboard();
    }
  };

  return (
    <>
      <button
        className={`${styles.onboardBtn} ${loading ? styles.loading : ''}`}
        onClick={handleOnboardClick}
        disabled={loading}
      >
        {loading ? 'Processing...' : 'Onboard with PayPal'}
      </button>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3>PayPal Merchant Found</h3>
            <p>We found an existing merchant account. Do you want to use it or create a new one?</p>
            <div className={styles.modalActions}>
              <button onClick={useExistingMerchant} disabled={loading}>
                Use Existing
              </button>
              <button onClick={onboard} disabled={loading}>
                Create New
              </button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

PayPalOnboard.propTypes = {
  eventId: PropTypes.string.isRequired,
};

export default PayPalOnboard;
